import { CommonModule, NgOptimizedImageModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ButtonsModule } from '@app/infrastructure/buttons/buttons.module';
import { GridModule } from '@app/infrastructure/data-list/grid/grid.module';
import { EmptyValueModule } from '@app/infrastructure/pipes/empty-value/empty-value.module';
import { StateSwitcherModule } from '@app/infrastructure/state-switcher/state-switcher.module';
import { FullTextTooltipModule } from '@app/infrastructure/tooltips/full-text-tooltip/full-text-tooltip.module';
import { InfoTooltipModule } from '@app/infrastructure/tooltips/info-tooltip/info-tooltip.module';
import { ReactiveTypedFormsModule } from '@rxweb/reactive-form-validators';
import { PipesModule } from '@shared/pipes/pipes.module';
import { CommitmentFiltersComponent } from './commitment-filters/commitment-filters.component';
import { CommitmentListComponent } from './commitment-list.component';
import { CommitmentTotalRowComponent } from './commitment-total-row/commitment-total-row.component';
import { MainLogoModule } from '@app/infrastructure/components/main-logo/main-logo.module';

@NgModule({
	declarations: [CommitmentListComponent, CommitmentFiltersComponent, CommitmentTotalRowComponent],
	imports: [
		CommonModule,
		MatSlideToggleModule,
		PipesModule,
		EmptyValueModule,
		FullTextTooltipModule,
		GridModule,
		StateSwitcherModule,
		ReactiveTypedFormsModule,
		InfoTooltipModule,
		NgOptimizedImageModule,
		ButtonsModule,
		MainLogoModule,
	],
	exports: [CommitmentListComponent],
})
export class CommitmentListModule {}
